// OKRs live in effy-fe (mounted under `/w`); these builders only link across to it.
// Cycle ids do not map to effy-fe OKR ids, so cycle-scoped links land on the OKR lists.
const OKRS_ALL = '/w/okrs/all';
const OKRS_CYCLES = '/w/okrs/cycles';
const OBJECTIVE_CREATE = '/w/okrs/objectives/create';

const adminRoutes = {
  CycleManager: () => OKRS_CYCLES,

  CycleCreator: () => OKRS_CYCLES,

  CycleEditor: (_cycleId: string) => OKRS_CYCLES,

  CycleObjectives: (_cycleId: string) => OKRS_ALL,

  CycleReports: (_cycleId: string) => OKRS_CYCLES,

  ObjectiveCreator: () => OBJECTIVE_CREATE,

  ObjectiveEditor: (objectiveId: string) => `/w/okrs/objectives/${objectiveId}/edit`,
};

const learnerRoutes = {
  OKRs: () => OKRS_ALL,

  OKRsTab: (_tabId: string) => OKRS_ALL,

  OKRsCycles: () => OKRS_CYCLES,

  LearnerCycleObjectives: (_cycleId: string) => OKRS_ALL,

  LearnerObjectiveCreator: () => OBJECTIVE_CREATE,

  LearnerObjectiveCreatorNew: () => OBJECTIVE_CREATE,

  LearnerObjectiveEditor: (objectiveId: string) => `/w/okrs/objectives/${objectiveId}/edit`,
};

export { adminRoutes, learnerRoutes };
